




















/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import { PARKING_LOT_LIST, PARKING_LOT_EDIT } from '../router-names';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
// import { DEFAULT_DATE_FORMAT } from '@root/common/config'
import { CHANNEL_LIST } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
import AddEditChannel from './components/add-edit-channel.vue';
import { editInfoChannelList } from '../../../api/parking-lot-management/index';

@Component({
  components: { AddEditChannel }
})
export default class ChannelListEdit extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/channel-list';

  areaName: string = '';
  formData = {}; //编辑表单
  channelId: string = '';
  headTitle = '编辑通道';

  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '通道信息',
        location: {
          name: CHANNEL_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 生命周期函数
  created() {
    console.log(this.$route.params.channelId);
    this.channelId = this.$route.params.channelId;
    this.queryEditInfoChannelList(this.$route.params.channelId);
  }

  async queryEditInfoChannelList(channelId: string) {
    const { status, code, msg, data } = await editInfoChannelList({ channelId });
    // const { datas } = data
    console.log(data);
    this.formData = { ...data, channelId: this.channelId };
  }
  // 编辑成功
  isSubmitOk() {
    this.$router.replace({
      name: CHANNEL_LIST
    });
  }
  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: CHANNEL_LIST,
  //   })
  // }
}
